// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyCYwoSGErv5yM5w6P-edv7cm9vBVKJYVCs",
  authDomain: "itg-events.firebaseapp.com",
  projectId: "itg-events",
  storageBucket: "itg-events.appspot.com",
  messagingSenderId: "63953921353",
  appId: "1:63953921353:web:0bee2d231770a81f1da698",
  measurementId: "G-7F38YK1DNS"
};

// Initialize Firebase
export const db = firebase.initializeApp(firebaseConfig).firestore();
db.settings({ timestampsInSnapshots: true })
